<template>
  <div class="grid pb-0">
    <div class="grid-title">
      <h4>{{ $t("SERVICES") }} - {{ $t('CHAIN') }}</h4>
      <div>
        <v-row>
          <v-col class="text-right pt-0 pb-0">
            <!-- <v-btn color="warning" v-if="radioGroup === true && selected.length > 0" @click="dialog = true" class="mr-3">{{ $t("DEACTIVE") }}</v-btn>
            <v-btn color="success" v-if="radioGroup === false && selected.length > 0" @click="dialogActive = true" class="mr-3">{{ $t("SERVICE.ACTIVE") }}</v-btn>
            <v-btn color="error" v-if="selected.length > 0" @click="$refs.deleteDialogComponentList.open(selected)" class="mr-3">{{ $t("DELETE") }}</v-btn> -->
            <v-btn color="primary" @click="addNew">
              <v-icon dark>
                mdi-plus
              </v-icon>
              {{ $t("ADD_NEW_SERVICE") }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="grid-body border-top-unset">
      <v-row align="center" class="pb-3 pr-3 pl-3">
        <v-col sm="4">
          <v-text-field v-model="keyword" :label="$t('ENTER_NAME_OR_CODE')" v-on:keyup="filterByNameOrCode()"
            class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col>
          <v-radio-group row v-model="radioGroup" class="mt-0" @change="$event => filterStatus($event)">
            <v-radio v-for="item in optionFilter" :key="item.key" :label="item.label" :value="item.key"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <div>
        <v-simple-table>
          <!-- <template v-slot:default> -->
          <thead>
            <tr>
              <!-- <th width="3%" scope="col">
                      <label class="form-checkbox">
                          <input class="v-input--selection-controls__input" type="checkbox" :value="true" v-model="checkAll"  @change="getAll()">
                          <i class="form-icon"></i>
                      </label>
                  </th> -->
              <th width="2%" class="text-center vertical-middle" scope="col">{{ $t("STT") }}</th>
              <!-- <th width="7%"  class="text-left"  scope="col" v-if="radioGroup === 'all' || radioGroup == true"><span>{{ $t("SERVICE.ORDER") }}</span></th> -->
              <th width="15%" class="text-left" scope="col">{{ $t("SERVICE.CODE") }}</th>
              <th width="15%" class="text-left" scope="col">{{ $t("SERVICE.NAME") }}</th>
              <th width="15%" class="text-left" scope="col">{{ $t("SERVICE.PRICE_STATUS") }}</th>
              <th width="10%" class="text-center vertical-middle" scope="col">{{ $t("SERVICE.STATUS") }}</th>
              <th width="10%" class="text-center vertical-middle" scope="col">{{ $t("ACTION") }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- <draggable  v-if="!isLoading" v-model="listFilter" tag="tbody" animation="150" handle=".sortHandle" @end="changeOrderListService"> -->
            <template v-if="listFilter.length > 0 && !isLoading">
              <tr v-for="(item, i) in listFilter" :key="i">
                <!-- <td width="3%" class="vertical-middle">
                        <label class="form-checkbox">
                          <input class="v-input--selection-controls__input" type="checkbox" :value="item" v-model="selected"  @change="checkAllSelect()">
                          <i class="form-icon"></i>
                      </label>
                    </td> -->
                <td width="2%" class="text-center vertical-middle">{{ i + 1 }}</td>
                <!-- <td width="7%" class="vertical-middle" v-if="radioGroup === 'all' || radioGroup == true"><v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn></td> -->
                <td width="15%" class="vertical-middle">
                  {{ item.serviceCode }}
                </td>
                <td width="15%" class="font-weight-bold vertical-middle">
                  <a v-if="item.serviceI18n" class="app-link text-decoration-none" href="javascript:;"
                    @click="editItem(item)">
                    {{ item.serviceI18n.find(x => x.lang == defaultI18n).name }}
                  </a>
                </td>
                <td width="15%" class="text-left vertical-middle">
                  <div v-if="item.free">
                    {{ $t("SERVICE.FREE") }}
                  </div>
                  <div v-else>
                    {{ $t("SERVICE.PREMIUM") }}
                  </div>
                </td>
                <td width="10%" class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch v-model="item.status" @change="updateStatus(item)"
                      class="service-status mt-0 pt-0"></v-switch>
                  </div>
                </td>
                <td width="10%" class="text-center vertical-middle">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed @click="editItem(item)" x-small class="rounded-sm mr-1" v-bind="attrs" v-on="on"
                        color="primary" outlined>
                        <i class="icon-edit fs-16"></i>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="error" @click="$refs.deleteDialogComponent.open(item)" x-small
                        v-bind="attrs" v-on="on" class="rounded-sm" outlined>
                        <i class="icon-delete fs-16"></i>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                  <!-- <v-tooltip top transition="slide-y-reverse-transition" v-if="radioGroup === 'all' || radioGroup == true">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            depressed
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            class="rounded-sm sortHandle ml-1"
                            outlined
                            style="cursor: move"
                          >
                            <v-icon size="15">
                              mdi-arrow-all
                            </v-icon>
                          </v-btn>
                        </template>
                        {{ $t("SORT") }}
                      </v-tooltip> -->
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="8" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                  {{ $t('NO_DATA') }}
                </td>
              </tr>
            </template>
            <!-- </draggable> -->
          </tbody>
          <!-- </template> -->
        </v-simple-table>
        <delete-dialog @deleteItem="deleteService" :maxWidth="325" ref="deleteDialogComponent">
          <span slot="title">{{ $t("SERVICE.CONFIRM_DELETE_SERVICE") }}?</span>
        </delete-dialog>
        <delete-dialog @deleteItem="deleteServiceList" :maxWidth="325" ref="deleteDialogComponentList">
          <span slot="title">{{ $t("SERVICE.CONFIRM_DELETE_SERVICE") }}</span>
        </delete-dialog>
        <v-dialog v-model="dialog" max-width="418">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{ $t('NOTIFICATION') }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <label class="s-label">{{ $t('SERVICE.CONFIRM_DEACTIVE_SERVICE') }}</label>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialog = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="deactiveAll">
                  {{ $t("CONFIRM") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
        <v-dialog v-model="dialogActive" max-width="325">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title class="text-primary fs-15">
              <strong>{{ $t('NOTIFICATION') }}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <label class="s-label">{{ $t('SERVICE.CONFIRM_ACTIVE_SERVICE') }}</label>
            <div class="mt-3 d-flex justify-content-between">
              <div class="w-100 mr-1">
                <v-btn depressed block @click="dialogActive = false">
                  {{ $t("_LOGIN.CANCEL") }}
                </v-btn>
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="deactiveAll">
                  {{ $t("CONFIRM") }}
                </v-btn>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.table-syncPMS {
  padding: 0;

  .v-card__text {
    padding: 0;
  }
}

#service-list {
  td {
    vertical-align: middle;
  }

  button.sortHandle {
    outline: none;
  }

  .service-status {
    justify-content: center;
    margin-top: 5px;
  }
}
</style>

<script>
import Paging from "@/components/Utils/Paging.vue";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import { ChainService } from "@/_services/ChainManage/chainService.service.js";
import draggable from "vuedraggable";
const toLower = text => {
  return text.toString().toLowerCase()
}
export default {
  components: {
    "delete-dialog": DeleteDialog,
    "confirm-dialog": ConfirmDialog,
    paging: Paging,
    draggable
  },
  data() {
    return {
      dialog: false,
      dialogActive: false,
      checkAll: false,
      isLoading: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("SERVICE.THUMBNAIL"),
          value: "defaultImageThumbUrl",
          width: "120px"
        },
        {
          text: this.$t("SERVICE.CODE"),
          value: "serviceCode"
        },
        {
          text: this.$t("SERVICE.NAME"),
          value: "serviceI18n",
        },
        {
          text: this.$t("SERVICE.PRICE_STATUS"),
          value: "free",
        },
        {
          text: this.$t("SERVICE.STATUS"),
          class: "text-center",
          value: "status",
        },
        {
          text: this.$t("ACTION"),
          class: "text-center",
          value: "action",
        }
      ],
      sysLang: this.$i18n.locale || "vi",
      radioGroup: 'all',
      selected: [],
      listService: [],
      listFilter: [],
      dragging: false,
      dialog: false,
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      selected: [],
      optionFilter: [
        {
          label: this.$t("ALL"),
          key: 'all'
        },
        {
          label: this.$t("SERVICE.ACTIVE"),
          key: true
        },
        {
          label: this.$t("SERVICE.DEACTIVE"),
          key: false
        }
      ],
      keyword: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.isLoading = true;
      await ChainService.get().then(res => {
        this.listService = res.data.services;
        this.listFilter = res.data.services;
        this.searched = res.data.services;
      })
      this.filterStatus('all');
    },
    // changeOrderListService(){
    //   const tmp = [];
    //   this.listFilter.forEach( element=> {
    //     tmp.push(element.id);
    //   } );

    //   ChainService.sortService(tmp).then(res => {
    //     // _alert(res, this.$t(res.data), res.responseCode != 0 );
    //   });
    // },
    getAll() {
      if (this.checkAll === true) {
        this.selected = [...this.listFilter];
      } else {
        this.selected = [];
      }
    },
    checkAllSelect() {
      if (this.selected.length === this.listFilter.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    updateStatus(item) {
      ChainService.updateStatus(item.id).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    },
    deactiveAll() {
      const body = [];
      this.selected.forEach(element => {
        body.push(element.id);
      }
      );
      ChainService.updateStatusAll(body).then(res => {
        this.dialog = false;
        _alert(res, this.$t(res.data), res.responseCode === 0);
      });
    },
    searchByNameorCode(items, term) {
      if (term) {
        return items.filter(item =>
          toLower(item.serviceI18n.find(x => x.lang == this.defaultI18n).name).includes(toLower(term))
          || toLower(item.serviceCode).includes(toLower(term)))
      }

      return items
    },
    filterByNameOrCode() {
      this.searched = this.searchByNameorCode(this.listService, this.keyword);
      this.filterStatus(this.radioGroup);
    },
    filterStatus(event) {
      this.isLoading = true;
      this.checkAll = false;
      this.getAll();
      let arr = []
      if (event == 'all') {
        arr = this.searched;
      } else {
        arr = this.searched.filter(item => item.status === event);
      }
      this.listFilter = JSON.parse(JSON.stringify(arr))
      setTimeout(() => {
        this.isLoading = false
      }, 100);
    },
    addNew() {
      this.$router.push({ name: "chain-service-detail", params: { type: 'create', id: 0 } });
    },
    editItem(item) {
      this.$router.push({ name: "chain-service-detail", params: { type: 'edit', id: item.id } });
    },
    deleteService(item) {
      ChainService.deleteService(item.id).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    },
    deleteServiceList(items) {
      const body = [];
      items.forEach(element => {
        body.push(element.id);
      }
      );
      ChainService.deleteServiceList(body).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    },
  }
};
</script>